import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/home',
        name: 'home-anchor',
        component: () => import('./views/Home.vue'),
        props: { 
          setState: '' 
        }
      },
      {
        path: '/developments',
        name: 'developments',
        component: () => import('./views/Developments.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/sell',
        name: 'sell',
        component: () => import('./views/Sell.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/properties',
        name: 'portfolio',
        component: () => import('./views/Portfolio.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/property/:propertyId',
        component: () => import('./views/Property.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/commercial',
        component: () => import('./views/Commercial.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/commercial-property/:propertyId',
        component: () => import('./views/CommercialProperty.vue'),
				props: {
					setState: ''
				}
      },
      {
        path: '/development/:propertyId',
        component: () => import('./views/DevelopmentProperty.vue'),
				props: {
					setState: ''
				}
      },
    ],
	  scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return {
          selector: to.hash,
          behavior: 'smooth' // Enables smooth scrolling if desired
        };
      } else {
        return { x: 0, y: 0 }; // Default scroll to top if no hash
      }
    }
  })
}
